import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 3rem;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 99999;
  width: 100%;

  & > div {
    position: relative;
    margin-bottom: 1rem;
  }
`;
